export default __webpack_public_path__ + "static/media/Belt of Tribulation.7e30fd28.jpg";